import { TextFieldProps } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import React from "react";
import { useFieldValueAndValidation } from "ui/componentes/Form/functions";
import CustomSelect, { CustomSelectProps } from "./CustomSelect";

const SelectFieldFormik: React.FC<CustomSelectProps & TextFieldProps> = (
    props
) => {
    const { values, setFieldValue, setFieldTouched } = useFormikContext<any>();
    const { error, hasTouched } = useFieldValueAndValidation(props.name);
    const showError = !!error && hasTouched;
    return (
        <Field
            value={values[props.name || ""] || ""}
            onChange={(v) => {
                if (props.onChange) {
                    props.onChange(v);
                    return;
                }
                setFieldTouched(props.name || "", true);
                setFieldValue(props.name || "", v.target.value);
            }}
            component={CustomSelect}
            {...props}
            error={showError}
            helperText={showError ? error : props.helperText}
            onBlur={() => setFieldTouched(props.name || "", true)}
        />
    );
};

export { SelectFieldFormik };
